import { ClassName } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { DashboardTheme } from 'containers/dashboard/types/types';
import './DashboardCardTitle.scss';

export interface IDashboardCardTitleProps {
  children: string;
  theme: DashboardTheme;
  className?: ClassName;
}

export default function DashboardCardTitle({ theme, children, className }: IDashboardCardTitleProps) {
  const classes = classNames('dashboard-card-title', theme, className);
  return <h2 className={classes}>{children}</h2>;
}
